module.exports = __webpack_public_path__ + "img/left-bg.2b506724.png";